const {
  ANSWER_TEMPLATE,
  normalizeAnswerTemplate,
} = require("../constants/answerTemplates");

// 작성 화면과 PDF는 같은 CSS 좌표계에서 줄을 배치한 후, 종이 크기에 맞춰
// 전체를 축소한다. 글자 수로 나누면 영문, 공백, 특수문자의 폭을 잃게 된다.
const getAnswerLayout = (templateType) => {
  const isMinistry =
    normalizeAnswerTemplate(templateType) ===
    ANSWER_TEMPLATE.MINISTRY_OF_JUSTICE;
  const width = isMinistry ? 784 : 938;
  const padding = isMinistry ? 0 : 18;
  const lineHeight = isMinistry ? 24 : 40;

  return {
    width,
    padding,
    contentWidth: width - padding * 2,
    gutterWidth: isMinistry ? 80 : 40,
    topSpacerHeight: isMinistry ? 104 : 80,
    lineHeight,
    firstPageRows: 30,
    normalPageRows: 34,
    minimumPageCount: isMinistry ? 2 : 4,
    pageGroupSize: isMinistry ? 1 : 4,
    textStyle: {
      fontFamily: isMinistry
        ? '"IBT Noto Sans KR", "Malgun Gothic", sans-serif'
        : '"Noto Sans KR", "Malgun Gothic", sans-serif',
      fontSize: isMinistry ? "16px" : "20px",
      fontWeight: "400",
      // 새 인쇄 창/SVG에도 앱의 전역 글꼴 렌더링 설정을 명시한다.
      fontFeatureSettings: '"kern"',
      textRendering: "optimizeLegibility",
      color: "#1a202c",
      lineHeight: `${lineHeight}px`,
      letterSpacing: isMinistry ? "1.25px" : "normal",
      wordBreak: isMinistry ? "break-all" : "normal",
      lineBreak: isMinistry ? "anywhere" : "auto",
      overflowWrap: isMinistry ? "break-word" : "normal",
      whiteSpace: isMinistry ? "normal" : "pre-wrap",
      WebkitFontSmoothing: "antialiased",
    },
  };
};

module.exports = { getAnswerLayout };
